module.exports = __webpack_public_path__ + "static/img/bannar.3189e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannar.png
// module id = Rndz
// module chunks = 1